import Cookies from 'universal-cookie'
import * as loginActions from 'mb-app-common/store/actions/auth'
import objectPath from 'object-path'

export default function(store){
	const cookies = new Cookies()

	return next => action => {
		if(action.type === 'persist/REHYDRATE' && objectPath.get(action, ['payload', 'Auth', 'token'], false)){
			// As SessionStorage only works per tab, we need to use LocalStorage to emulate a "session", so to prevent the localStorage token
			// from persisting over browser sessions, we guard it with a session cookie
			// If session cookie doesn't exist, don't rehydrate the token
			if(cookies.get('isSession')){
				store.dispatch({
					type: loginActions.LOGIN_SUCCESS,
					token: action.payload.Auth.token
				})
			}else{
				delete action.payload.Auth.token
			}
		}

		if(action.type == loginActions.LOGIN_SUCCESS && !cookies.get('isSession')){
			cookies.set("isSession", true, {expires: 0, path: '/'})
		}

		return next(action)
	}
}



// WEBPACK FOOTER //
// ./client/store/middleware/rehydrated-login.js